import React, { useEffect, useState } from "react";
import { Box,Typography,List,ListItem,ListItemIcon,ListItemText,IconButton,Collapse,Drawer,Tooltip,} from "@mui/material";
import CRMlogo from "../../../../assest/images/crm -1 3.png";
import PropTypes from "prop-types";
import { Link, NavLink, useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled, useMediaQuery } from "@mui/system";
//import routes from "../../../../routes"; // Ensure routes have nested structures
import { setMiniSidenav, useMaterialUIController } from "../../../../context";
import MaterialBox from "../../../../components/MaterialBox";
const Logo = styled(Typography)(({ isCollapsed }) => ({
  
  // fontSize: isCollapsed ? "0px" : "24px",
  fontWeight: "bold",
  // marginBottom: "20px",
  // paddingTop: "30px",
  color: "#6a0dad",
  transition: "font-size 0.3s ease-in-out, opacity 0.4s ease-in-out",
  opacity: isCollapsed ? 0 : 1,
}));

const NewSidebar = ({ brand, brandName,routes }) => {

  const userRole = localStorage.getItem("userRole");
  const SidebarContainer = styled(Box)(({ isCollapsed }) => ({
    width: !isMobile ? (isCollapsed ? "70px" : "200px") : "200px",
    background:!isMobile?
      "linear-gradient(90deg, rgba(255, 255, 255, 0.4) 0%, rgba(236, 245, 255, 0.4) 50%, rgba(210, 231, 255, 0.4) 100%)":"#fff",
    padding: isCollapsed ? "10px" : "10px",
    boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
    borderRadius: "0px 20px 20px 10px",
    height: "100vh",
    display: "flex",
    zIndex: 9999,
    flexDirection: "column",
    // transition: "width 0.4s ease-in-out, padding 0.4s ease-in-out",
    transition: "padding-top 0.4s ease, padding 0.4s ease",
   
    position: "fixed",
    overflowY: "auto",
    overflowX: "hidden",
  }));
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [openMenus, setOpenMenus] = useState({});
  const [selectCollapseIndex, setSelectCollapseIndex] = useState(null);

  const isMobile = useMediaQuery("(max-width: 1024px)");
  const isMobileforview = useMediaQuery("(max-width: 250px)");
  const [mobileOpen, setMobileOpen] = useState(false);
  const index=selectedIndex

  useEffect(() => {
    if (selectedIndex !== null && selectCollapseIndex !== null) {
      setSelectCollapseIndex(null);
    }
  }, [selectedIndex]);
  
  useEffect(() => {
    if (selectedIndex !== null && selectCollapseIndex !== null) {
      setSelectedIndex(null); // Reset main index when selecting a collapsible route
    }
  }, [selectCollapseIndex]);
  
  

const navigate = useNavigate();
const pathName=window.location.pathname
  useEffect(()=>{
       if(pathName==="/dashboard")
       {
        setSelectedIndex(0)
        
       }
       else
       {
        const currentPath = window.location.pathname;

        const value = routes.filter(
          (route) =>
            route.name !== "Authentication" &&
            route.name !== "Onboarding" &&
            route.isShow !== true
        ).findIndex(route => {
         
            return route.route === currentPath || (route.collapse && route.collapse.some(sub => sub.route === currentPath));
        });
        setSelectedIndex(value)
       }
   },[])

  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const onClose = () => {
    handleMiniSidenav();
  };

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  const handleCollapseListItemClick = (index, keyVal) => {
    setSelectCollapseIndex(keyVal);
  };

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
  };

  const toggleMenu = (key, name) => {
    setOpenMenus((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  return (
    <>
      {isMobile ? (
     <div style={{ display: miniSidenav ? 'block' : 'none',
      overflow: 'hidden',
      transition: 'opacity 0.3s ease, max-height 0.3s ease',
      opacity: miniSidenav ? 1 : 0,
      maxHeight: miniSidenav ? '500px' : '0',
      visibility: miniSidenav ? 'visible' : 'hidden',
     }}>
    <IconButton
      onClick={() => {
        onClose();
      }}
      sx={{
        position: "fixed",
        top: isCollapsed ? "4.5%" : "5%",
        // left: isCollapsed ? "4.5%" : "16%",
        left: isMobileforview ? "75%" : isMobile ? "25%" : "30%",
        zIndex: 9999999,
        backgroundColor: "#fff",
        borderRadius: "50%",
        color: "#000",
        fontSize: "14px",
        mr: 1,
        boxShadow: "0px 0px 10px 0px #0000001A",
        "&:hover": {
          backgroundColor: "#f0f0f0",
        },
      }}
    >
   
    <CloseIcon/>
    </IconButton>
    <SidebarContainer
      isCollapsed={isCollapsed}
      className="custom-scrollbar"
      xs={12}
      md={4}
      lg={3}
    >
      <style>
        {`
  /* Targeting the scrollbar inside the div with class 'custom-scrollbar' */
  .custom-scrollbar::-webkit-scrollbar {
    width: 0px; /* Width of the scrollbar */
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1); /* Background of the track */
    border-radius: 10px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: #FFFFFF; /* Blue color for the scrollbar */
    border-radius: 10px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: #FFFFFF; /* Darker blue when hovered */
  }
`}
      </style>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "10%",
          gap: "10px",
          position: "relative",
        }}
      >
        <MaterialBox component="img" src={CRMlogo} />
        
        {isCollapsed==false&&
        <Logo isCollapsed={isCollapsed}>{brandName}</Logo>}
      </Box>

      <List>
        {routes
          .filter(
            (route) =>
              route.name !== "Authentication" &&
              route.name !== "Onboarding" &&
              route.isShow !== true 
             
          )
          .map((route, index) => (
            <Box key={index} sx={{ position: "relative" }}>
              {selectedIndex === index && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    right: isCollapsed ? "-8px" : "-12px",
                    height: "100%",
                    width: "6px",
                    backgroundColor: "#6a0dad",
                    borderRadius: "4px",
                    transition:
                      "right 0.3s ease-in-out, width 0.3s ease-in-out, background-color 0.3s ease-in-out",
                  }}
                />
              )}

              {/* If the route has a submenu (collapse), render differently */}
              {route.collapse ? (
                <>
                  <ListItem
                    button
                    onClick={() => toggleMenu(route.key, route.name)}
                    sx={{
                      borderRadius: "8px",
                      marginBottom: "5px",
                      padding: "10px",
                      color: "#000",
                      transition:
                        "background-color 0.3s ease-in-out, padding 0.3s ease-in-out",
                      "&:hover": {
                        backgroundColor: "#e0e0e0",
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        transition: "color 0.3s ease-in-out",
                        color: "#000",
                        fontSize:'20px'
                      }}
                    >
                      {route.icon}
                     
                      {isCollapsed ? (
                       
                        openMenus[route.key] ? (
                          <ExpandLessIcon />
                        
                        ) : (
                          <ExpandMoreIcon />
                          
                        )
                      ) : (
                        ""
                      )}
                    </ListItemIcon>
                    {!isCollapsed && (
                      <Typography fontSize={"16px"} fontFamily={"Aptos"}>
                        {route.name}
                      </Typography>
                      // <ListItemText
                      //   primary={route.name}
                      //   sx={{ transition: "color 0.3s ease-in-out" }}
                      // />
                    )}

                    {openMenus[route.key] ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                      
                    )}
                  </ListItem>

                  {/* Render Submenu Items */}
                  <Collapse
                    in={openMenus[route.key]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {route.collapse.map((subRoute, Index) => (
                        <ListItem
                          key={subRoute.key}
                          button
                          component={Link}
                          onClick={() =>
                            handleCollapseListItemClick(
                              Index,
                              subRoute.key
                            )
                          }
                          to={subRoute.route}
                          sx={{
                            padding: "10px",

                            backgroundColor:
                              selectCollapseIndex === subRoute.key
                                ? "#f0f0f0"
                                : "transparent",
                            borderRadius: "5px",
                            color:
                              selectCollapseIndex === subRoute.key
                                ? "#6a0dad"
                                : "#000",
                            margin: "3px 0",
                            "&:hover": { backgroundColor: "#ececec" },
                          }}
                        >
                          {selectCollapseIndex === subRoute.key && (
                            <Box
                              sx={{
                                position: "absolute",
                                top: 0,
                                right: isCollapsed ? "-8px" : "-12px",
                                height: "100%",
                                width: "6px",
                                backgroundColor: "#6a0dad",
                                borderRadius: "4px",
                                transition:
                                  "right 0.3s ease-in-out, width 0.3s ease-in-out, background-color 0.3s ease-in-out",
                              }}
                            />
                          )}
                          {isCollapsed ? (
                            <Tooltip
                              title={subRoute.name}
                              placement="right"
                              PopperProps={{
                                modifiers: [
                                  {
                                    name: "zIndex",
                                    enabled: true,
                                    phase: "main",
                                    fn: ({ state }) => {
                                      state.styles.popper.zIndex = 999999999;
                                    },
                                  },
                                ],
                              }}
                            >
                              <Typography
                                sx={{ pl: isCollapsed ? 1 : 3 }}
                                fontFamily={"Aptos"}
                                fontSize={"16px"}
                              >
                                {subRoute.name.charAt(0)}
                              </Typography>
                            </Tooltip>
                          ) : (
                            <Typography
                              sx={{ pl: isCollapsed ? 1 : 3 }}
                              fontFamily={"Aptos"}
                              fontSize={"16px"}
                            >
                              {subRoute.name}
                            </Typography>
                          )}
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </>
              ) : (
                <ListItem
                  button
                  component={Link}
                  to={route.route}
                  onClick={() => handleListItemClick(index)}
                  sx={{
                    backgroundColor:
                      selectedIndex === index ? "#f0f0f0" : "transparent",
                    borderRadius: "8px",
                    marginBottom: "5px",
                    padding: "10px",
                    color: selectedIndex === index ? "#6a0dad" : "#000",
                    transition:
                      selectedIndex === index
                        ? "background-color 0.3s ease-in-out, padding 1s ease-in-out"
                        : "background-color 0.3s ease-in-out, padding 0.3s ease-in-out",
                    "&:hover": {
                      backgroundColor: "#e0e0e0",
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      transition: "color 0.3s ease-in-out",
                      color: selectedIndex === index ? "#6a0dad" : "#000",
                      
                    }}
                  >
                    <Typography fontSize={"19px"}>
                      {route.icon}
                    </Typography>
                  </ListItemIcon>
                  {!isCollapsed && (
                    <Typography fontSize={"16px"} fontFamily={"Aptos"}>
                      {route.name}
                    </Typography>
                  )}
                </ListItem>
              )}
            </Box>
          ))}
      </List>
    </SidebarContainer>
    </div>

      ) : 
      (
        <>
          <IconButton
            onClick={() => {
              setIsCollapsed(!isCollapsed);
              onClose();
            }}
            sx={{
              position: "fixed",
              top: isCollapsed ? "4.5%" : "5%",
              left: isCollapsed ? "4.5%" : "14%",
              zIndex: 9999999,
              backgroundColor: "#fff",
              borderRadius: "50%",
              color: "#000",
              fontSize: "14px",
              mr: 1,
              boxShadow: "0px 0px 10px 0px #0000001A",
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
            }}
          >
            {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
          <SidebarContainer
            isCollapsed={isCollapsed}
            className="custom-scrollbar"
            xs={12}
            md={4}
            lg={3}
          >
            <style>
              {`
        /* Targeting the scrollbar inside the div with class 'custom-scrollbar' */
        .custom-scrollbar::-webkit-scrollbar {
          width: 0px; /* Width of the scrollbar */
        }
   
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.1); /* Background of the track */
          border-radius: 10px;
        }
   
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: #FFFFFF; /* Blue color for the scrollbar */
          border-radius: 10px;
        }
   
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background-color: #FFFFFF; /* Darker blue when hovered */
        }
      `}
            </style>
            <MaterialBox>
              <Box
              onClick = {() => navigate("/dashboard")}
                sx={{
                  marginLeft: "30px",
                  display: "flex",
                  alignItems: "center",
                  height: "10%",
                  gap: "10px",
                  position: "relative",
                  paddingBottom:miniSidenav?"40%":"12%",
                  paddingTop:miniSidenav?'30%':'12%',
                  cursor: "pointer",
                  transition: "padding-top 0.5s ease, padding-bottom 0.5s ease",
                }}
              >
                <MaterialBox component="img" src={CRMlogo} />
                <Logo  isCollapsed={isCollapsed}>{brandName}</Logo>
              </Box>

              <List>
                {routes
                  .filter(
                    (route) =>
                      route.name !== "Authentication" &&
                      route.name !== "Onboarding" &&
                      route.isShow !== true
                  )
                  .map((route, index) => (
                    <Box key={index} sx={{ position: "relative" }}>
                      {selectedIndex === index && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: isCollapsed ? "-8px" : "-10px",
                            height: "100%",
                            width: "6px",
                            backgroundColor: "#6a0dad",
                            borderRadius: "4px",
                            transition:
                              "right 0.3s ease-in-out, width 0.3s ease-in-out, background-color 0.3s ease-in-out",
                          }}
                        />
                      )}

                      {/* If the route has a submenu (collapse), render differently */}
                      {route.collapse ? (
                        <>
                          <ListItem
                            button
                            onClick={() => toggleMenu(route.key, route.name)}
                            sx={{
                              borderRadius: "8px",
                              marginBottom: "5px",
                              // padding: "10px",
                              paddingTop:'5px',
                              paddingBottom:'5px',
                              paddingLeft:'10px',
                              paddingRight:'10px',
                              color: "#000",
                              transition:
                                "background-color 0.3s ease-in-out, padding 0.3s ease-in-out",
                              "&:hover": {
                                backgroundColor: "#e0e0e0",
                              },
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                transition: "color 0.3s ease-in-out",
                                color: "#000",
                                fontSize:'20px',
                                minWidth:'30px'
                              }}
                            >
                              {route.icon}
                            
                              {isCollapsed ? (
                                openMenus[route.key] ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                
                                )
                              ) : (
                                ""
                              )}
                            </ListItemIcon>
                            {!isCollapsed && (
                              <Typography fontSize={"16px"} fontFamily={"Aptos"}>
                                {route.name}
                              </Typography>
                              // <ListItemText
                              //   primary={route.name}
                              //   sx={{ transition: "color 0.3s ease-in-out" }}
                              // />
                            )}
                            {
                            openMenus[route.key] ? (
                              !miniSidenav &&
                              <ExpandLessIcon />
                            ) 
                            : (
                              !miniSidenav &&
                              <ExpandMoreIcon />
                            )}
                          </ListItem>

                          {/* Render Submenu Items */}
                          <Collapse
                            in={openMenus[route.key]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List component="div" disablePadding>
                              {route.collapse.map((subRoute, Index) => (
                                <ListItem
                                  key={subRoute.key}
                                  button
                                  component={Link}
                                  onClick={() =>
                                    handleCollapseListItemClick(
                                      Index,
                                      subRoute.key
                                    )
                                  }
                                  to={subRoute.route}
                                  sx={{
                                    // padding: "10px",
                                    paddingTop:'2px',
                                    paddingBottom:'2px',
                                    paddingLeft:'10px',
                                    paddingRight:'10px',
                                    backgroundColor:
                                      selectCollapseIndex === subRoute.key
                                        ? "#f0f0f0"
                                        : "transparent",
                                    borderRadius: "5px",
                                    color:
                                      selectCollapseIndex === subRoute.key
                                        ? "#6a0dad"
                                        : "#000",
                                    margin: "3px 0",
                                    "&:hover": { backgroundColor: "#ececec" },
                                  }}
                                >
                                  {selectCollapseIndex === subRoute.key && (
                                    <Box
                                      sx={{
                                        position: "absolute",
                                        top: 0,
                                        right: isCollapsed ? "-8px" : "-12px",
                                        height: "100%",
                                        width: "6px",
                                        backgroundColor: "#6a0dad",
                                        borderRadius: "4px",
                                        transition:
                                          "right 0.3s ease-in-out, width 0.3s ease-in-out, background-color 0.3s ease-in-out",
                                      }}
                                    />
                                  )}
                                  {isCollapsed ? (
                                  
                                    <Tooltip
                                      title={subRoute.name}
                                      placement="right"
                                      PopperProps={{
                                        modifiers: [
                                          {
                                            name: "zIndex",
                                            enabled: true,
                                            phase: "main",
                                            fn: ({ state }) => {
                                              state.styles.popper.zIndex = 999999999;
                                            },
                                          },
                                        ],
                                      }}
                                    >
                                      <Typography
                                        sx={{ pl: isCollapsed ? 1 : 3 }}
                                        fontFamily={"Aptos"}
                                        fontSize={"16px"}
                                      >
                                        {subRoute.name.charAt(0)}
                                        {/* {subRoute.icon} */}
                                      </Typography>
                                    </Tooltip>
                                  ) : (
                                    <Typography
                                      sx={{ pl: isCollapsed ? 1 : 3 }}
                                      fontFamily={"Aptos"}
                                      fontSize={"16px"}
                                    >
                                      {subRoute.name}
                                    </Typography>
                                  )}
                                </ListItem>
                              ))}
                            </List>
                          </Collapse>
                        </>
                      ) : (
                        <ListItem
                          button
                          component={Link}
                          to={route.route}
                          onClick={() => handleListItemClick(index)}
                          sx={{
                            backgroundColor:
                              selectedIndex === index ? "#f0f0f0" : "transparent",
                            borderRadius: "8px",
                            marginBottom: "5px",
                            // padding: "10px",
                            paddingTop:'5px',
                            paddingBottom:'5px',
                            paddingLeft:'10px',
                            paddingRight:'10px',
                            color: selectedIndex === index ? "#6a0dad" : "#000",
                            transition:
                              selectedIndex === index
                                ? "background-color 0.3s ease-in-out, padding 1s ease-in-out"
                                : "background-color 0.3s ease-in-out, padding 0.3s ease-in-out",
                            "&:hover": {
                              backgroundColor: "#e0e0e0",
                            },
                          
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              transition: "color 0.3s ease-in-out",
                              color: selectedIndex === index ? "#6a0dad" : "#000",
                              minWidth:'30px'
                              
                            }}
                          >
                            <Typography fontSize={"19px"}>
                              {route.icon}
                            </Typography>
                          </ListItemIcon>
                          {!isCollapsed && (
                            <Typography fontSize={"16px"} fontFamily={"Aptos"}>
                              {route.name}
                            </Typography>
                          )}
                        </ListItem>
                      )}
                    </Box>
                  ))}
              </List>
            </MaterialBox>
          </SidebarContainer>
        </>
      )}
    </>
  );
};
NewSidebar.propTypes = {
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
};

export default NewSidebar;
